import { Action } from 'react-fetching-library';
import { HomepageResponse } from '../../../common/types';

export const getHomepageAction: any = () => <Action<HomepageResponse>>({
    method: 'POST',
    endpoint: '/home',
    body: {}
})